/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RelocateScreenerResidentRequest
 */
export interface RelocateScreenerResidentRequest {
    /**
     * 
     */
    bed_id: string;
    /**
     * 
     */
    bed_change_date: string;
}

/**
 * Check if a given object implements the RelocateScreenerResidentRequest interface.
 */
export function instanceOfRelocateScreenerResidentRequest(value: object): value is RelocateScreenerResidentRequest {
    if (!('bed_id' in value) || value['bed_id'] === undefined) return false;
    if (!('bed_change_date' in value) || value['bed_change_date'] === undefined) return false;
    return true;
}

export function RelocateScreenerResidentRequestFromJSON(json: any): RelocateScreenerResidentRequest {
    return RelocateScreenerResidentRequestFromJSONTyped(json, false);
}

export function RelocateScreenerResidentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RelocateScreenerResidentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'bed_id': json['bed_id'],
        'bed_change_date': json['bed_change_date'],
    };
}

export function RelocateScreenerResidentRequestToJSON(json: any): RelocateScreenerResidentRequest {
    return RelocateScreenerResidentRequestToJSONTyped(json, false);
}

export function RelocateScreenerResidentRequestToJSONTyped(value?: RelocateScreenerResidentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bed_id': value['bed_id'],
        'bed_change_date': value['bed_change_date'],
    };
}

